import React from 'react';
import Text from '@/components/ui/Text/Text';

const Example = () => (
  <Text variant="heading1">Skibbidy</Text>
);

export default Example;
